export default {
  'menu.welcome': '欢迎',
  'menu.home': '主页',
  'menu.login': '登录',
  'menu.meeting': '云会议'
}
